import gql from "graphql-tag";

// TODO(somewhatabstract, JIRA-XXX8): Improve our patterns so that we
// can pass a valid ApolloGqlClient from the react components.
// DO NOT COPY - bad example of how to get a ApolloGqlClient.
import {getUnsafeApolloGqlClient} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {PermissionsInfo} from "@khan/shared-core";

import type {
    MasteryLevel,
    MasteryMap,
} from "#content-types-package/mastery-types.ts";

import {
    updateFpmMastery,
    updateFpmMasteryComplete,
} from "./user-info-actions.ts";
import * as constants from "./user-info-constants.ts";
import type {Action, State} from "./user-info-reducer.ts";

export const handleSideEffects =
    (callbacks: any): ((next: any, action: Action, state: State) => void) =>
    (next: any, action: Action, state: State) => {
        switch (action.type) {
            case constants.SET_CURRENT_TOPIC:
                callbacks.onSetCurrentTopic &&
                    callbacks.onSetCurrentTopic(
                        next,
                        action.topicId,
                        action.masteryEnabled,
                    );
                break;
        }
    };

const FPM_MASTERY_QUERY: GqlOperation<
    FpmMasteryForTopic,
    FpmMasteryForTopicVariables
> = gqlOp(gql`
    query getFpmMasteryForTopic($topicId: String!) {
        user {
            id
            curationItemProgress(topicId: $topicId) {
                masteryMap {
                    progressKey
                    status
                }
                currentMastery {
                    percentage
                    pointsEarned
                    pointsAvailable
                }
            }
        }
    }
`);

type FpmMasteryForTopicVariables = {
    topicId: string;
};

type FpmMasteryForTopic = {
    user: {
        id: string;
        curationItemProgress: {
            masteryMap: Array<{
                progressKey: string;
                status: MasteryLevel;
            }>;
            currentMastery: {
                percentage: number;
                pointsEarned: number;
                pointsAvailable: number;
            };
        };
    };
};

export const defaultCallbacks = {
    onSetCurrentTopic: (
        dispatch: any,
        topicId: string,
        masteryEnabled: boolean,
    ) => {
        if (!masteryEnabled || !PermissionsInfo.hasProfile) {
            // Only phantoms/logged-in users seeing the mastery experience
            // should query the FPM mastery endpoint.
            return;
        }

        // TODO(somewhatabstract, JIRA-XXX8): Improve our patterns so that we
        // can pass a valid ApolloGqlClient from the react components.
        // DO NOT COPY - bad example of how to get a ApolloGqlClient.
        // eslint-disable-next-line no-restricted-syntax
        getUnsafeApolloGqlClient()
            .query(FPM_MASTERY_QUERY, {
                variables: {topicId},
                fetchPolicy: "network-only",
            })
            .then(({data}) => {
                const {curationItemProgress}: FpmMasteryForTopic["user"] =
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    data.user;

                // TODO: deduplicate with code in curation-page.jsx
                const masteryMap: MasteryMap =
                    curationItemProgress.masteryMap.reduce<Record<string, any>>(
                        (map: MasteryMap, {progressKey, status}) => {
                            return {
                                ...map,
                                [progressKey]: status,
                            };
                        },
                        {},
                    );

                const fpmMasteryData = {
                    masteryMap: masteryMap,
                    masteryPercentage:
                        curationItemProgress.currentMastery.percentage,
                    masteryPointsEarned:
                        curationItemProgress.currentMastery.pointsEarned,
                    masteryPointsAvailable:
                        curationItemProgress.currentMastery.pointsAvailable,
                } as const;

                // FUTURE(kevinb): This triggers a request for updated
                // data from the server.  But we could do that update
                // on the client-side since we have all of the information
                // already.
                dispatch(updateFpmMastery(fpmMasteryData));
            })
            .then(() => {
                dispatch(updateFpmMasteryComplete());
            });
    },
} as const;
